// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/banner-promo-overlay/banner-promo-overlay.component.scss
// module id = 579
// module chunks = 0